import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { fluxButtonBase, fluxButtonSizes, fluxButtonSquareSizes, fluxButtonVariants, resolveButtonVariant, } from "../flux/variants.js";
function normalizeSize(size) {
    if (size === "md")
        return "base";
    if (size === "lg")
        return "base";
    return size;
}
export const Button = React.forwardRef(({ variant = "primary", size = "base", square = false, className = "", disabled, children, ...rest }, ref) => {
    const fluxVariant = resolveButtonVariant(variant);
    const fluxSize = normalizeSize(size);
    const sizeClass = square ? fluxButtonSquareSizes[fluxSize] : fluxButtonSizes[fluxSize];
    return (_jsx("button", { ref: ref, disabled: disabled, className: [fluxButtonBase, fluxButtonVariants[fluxVariant], sizeClass, className].join(" "), ...rest, children: children }));
});
Button.displayName = "Button";
